// extracted by mini-css-extract-plugin
export default {"title":"orders_title__R1X7f","orders":"orders_orders__QY5ON","filters":"orders_filters__Lz-nA","active":"orders_active__hlf8r"};